import { useState } from "react";
import { supabase } from "../lib/SupabaseClient";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        setMessage(null);

        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo:
                import.meta.env.MODE === "development"
                    ? "http://localhost:5210/reset-password"
                    : "https://secureidtechnologies.com/reset-password",
        });

        if (error) {
            setError(error.message);
        } else {
            setMessage("✅ Check your email for the reset link.");
        }

        setBusy(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-900 text-center">
                    Forgot Password
                </h2>
                <p className="mt-2 text-sm text-gray-600 text-center">
                    Enter your email and we’ll send you a link to reset your password.
                </p>

                {error && (
                    <div className="mt-4 rounded bg-red-50 p-3 text-red-700 text-sm">
                        {error}
                    </div>
                )}
                {message && (
                    <div className="mt-4 rounded bg-green-50 p-3 text-green-700 text-sm">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                    />
                    <button
                        type="submit"
                        disabled={busy}
                        className="w-full bg-indigo-600 text-white py-2 rounded-lg font-medium hover:bg-indigo-700 transition disabled:opacity-60"
                    >
                        {busy ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>

                {/* Back to login link */}
                <p className="mt-6 text-center text-sm text-gray-600">
                    Remembered your password?{" "}
                    <Link to="/login" className="text-indigo-600 hover:underline">
                        Go back to Login
                    </Link>
                </p>
            </div>
        </div>
    );
}
